var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1728 1117",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_4507)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M0 0H1728V253C1728 730.174 1341.17 1117 864 1117V1117C386.826 1117 0 730.174 0 253V0Z",
    fill: "var(--s_m_background_color)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1051.31 568.561C1045.65 474.095 970.058 398.498 875.592 392.838C881.253 487.303 956.849 562.9 1051.31 568.561Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M852.829 392.838C847.168 487.303 771.571 562.9 677.105 568.561C682.766 474.095 758.363 398.498 852.829 392.838V392.838Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M677.105 591.324C682.766 685.79 758.363 761.386 852.829 767.047C847.168 672.581 771.571 596.985 677.105 591.324Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M875.592 767.027C881.253 672.561 956.849 596.965 1051.31 591.304C1045.65 685.77 970.058 761.366 875.592 767.027Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1460.67 568.561C1455.01 474.095 1379.42 398.498 1284.95 392.838C1290.61 487.303 1366.21 562.9 1460.67 568.561Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1262.19 392.838C1256.53 487.303 1180.93 562.9 1086.46 568.561C1092.12 474.095 1167.72 398.498 1262.19 392.838V392.838Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1086.48 591.324C1092.14 685.79 1167.74 761.386 1262.21 767.047C1256.55 672.581 1180.95 596.985 1086.48 591.324Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1284.95 767.027C1290.61 672.561 1366.21 596.965 1460.67 591.304C1455.01 685.77 1379.42 761.366 1284.95 767.027Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M266.844 568.561C272.504 474.095 348.101 398.498 442.566 392.838C436.906 487.303 361.309 562.9 266.844 568.561Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M465.311 392.838C470.971 487.303 546.568 562.9 641.033 568.561C635.373 474.095 559.776 398.498 465.311 392.838V392.838Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M641.033 591.324C635.373 685.79 559.776 761.386 465.311 767.047C470.971 672.581 546.568 596.985 641.033 591.324Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M442.547 767.027C436.886 672.561 361.29 596.965 266.824 591.304C272.485 685.77 348.081 761.366 442.547 767.027Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1051.31 965.513C1045.65 871.048 970.058 795.451 875.592 789.791C881.253 884.256 956.849 959.853 1051.31 965.513Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M852.829 789.791C847.168 884.256 771.571 959.853 677.105 965.513C682.766 871.048 758.363 795.451 852.829 789.791Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M677.105 988.277C682.766 1082.74 758.363 1158.34 852.829 1164C847.168 1069.53 771.571 993.938 677.105 988.277Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M875.592 1164C881.253 1069.53 956.849 993.938 1051.31 988.277C1045.65 1082.74 970.058 1158.34 875.592 1164Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1460.67 965.513C1455.01 871.048 1379.42 795.451 1284.95 789.791C1290.61 884.256 1366.21 959.853 1460.67 965.513Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1262.19 789.791C1256.53 884.256 1180.93 959.853 1086.46 965.513C1092.12 871.048 1167.72 795.451 1262.19 789.791Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1086.48 988.277C1092.14 1082.74 1167.74 1158.34 1262.21 1164C1256.55 1069.53 1180.95 993.938 1086.48 988.277Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1284.95 1164C1290.61 1069.53 1366.21 993.938 1460.67 988.277C1455.01 1082.74 1379.42 1158.34 1284.95 1164Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M266.844 965.513C272.504 871.048 348.101 795.451 442.566 789.791C436.906 884.256 361.309 959.853 266.844 965.513Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M465.311 789.791C470.971 884.256 546.568 959.853 641.033 965.513C635.373 871.048 559.776 795.451 465.311 789.791V789.791Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M641.033 988.277C635.373 1082.74 559.776 1158.34 465.311 1164C470.971 1069.53 546.568 993.938 641.033 988.277Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M442.547 1164C436.886 1069.53 361.29 993.938 266.824 988.277C272.485 1082.74 348.081 1158.34 442.547 1164Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1051.31 175.723C1045.65 81.2573 970.058 5.66072 875.592 0C881.253 94.4657 956.849 170.062 1051.31 175.723Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M852.829 0.0200195C847.168 94.4858 771.571 170.083 677.105 175.743C682.766 81.2775 758.363 5.68074 852.829 0.0200195Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M677.105 198.486C682.766 292.952 758.363 368.549 852.829 374.209C847.168 279.744 771.571 204.147 677.105 198.486Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M875.592 374.209C881.253 279.744 956.849 204.147 1051.31 198.486C1045.65 292.952 970.058 368.549 875.592 374.209Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1460.67 175.723C1455.01 81.2573 1379.42 5.66072 1284.95 0C1290.61 94.4657 1366.21 170.062 1460.67 175.723Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1262.19 0.0200195C1256.53 94.4858 1180.93 170.083 1086.46 175.743C1092.12 81.2775 1167.72 5.68074 1262.19 0.0200195Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1086.48 198.486C1092.14 292.952 1167.74 368.549 1262.21 374.209C1256.55 279.744 1180.95 204.147 1086.48 198.486Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1284.95 374.209C1290.61 279.744 1366.21 204.147 1460.67 198.486C1455.01 292.952 1379.42 368.549 1284.95 374.209Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1856.26 568.561C1850.6 474.095 1775 398.498 1680.54 392.838C1686.2 487.303 1761.79 562.9 1856.26 568.561Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1657.77 392.838C1652.11 487.303 1576.52 562.9 1482.05 568.561C1487.71 474.095 1563.31 398.498 1657.77 392.838V392.838Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1482.05 591.324C1487.71 685.79 1563.31 761.386 1657.77 767.047C1652.11 672.581 1576.52 596.985 1482.05 591.324Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1680.54 767.027C1686.2 672.561 1761.79 596.965 1856.26 591.304C1850.6 685.77 1775 761.366 1680.54 767.027Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1856.26 965.513C1850.6 871.048 1775 795.451 1680.54 789.791C1686.2 884.256 1761.79 959.853 1856.26 965.513Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1657.77 789.791C1652.11 884.256 1576.52 959.853 1482.05 965.513C1487.71 871.048 1563.31 795.451 1657.77 789.791Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1482.05 988.277C1487.71 1082.74 1563.31 1158.34 1657.77 1164C1652.11 1069.53 1576.52 993.938 1482.05 988.277Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1680.54 1164C1686.2 1069.53 1761.79 993.938 1856.26 988.277C1850.6 1082.74 1775 1158.34 1680.54 1164Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1856.26 175.723C1850.6 81.2573 1775 5.66072 1680.54 0C1686.2 94.4657 1761.79 170.062 1856.26 175.723Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1657.77 0.0200195C1652.11 94.4858 1576.52 170.083 1482.05 175.743C1487.71 81.2775 1563.31 5.68074 1657.77 0.0200195Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1482.05 198.486C1487.71 292.952 1563.31 368.549 1657.77 374.209C1652.11 279.744 1576.52 204.147 1482.05 198.486Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M1680.54 374.209C1686.2 279.744 1761.79 204.147 1856.26 198.486C1850.6 292.952 1775 368.549 1680.54 374.209Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M246.368 568.561C240.708 474.095 165.111 398.498 70.6455 392.838C76.3062 487.303 151.902 562.9 246.368 568.561Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M47.8824 392.838C42.2217 487.303 -33.3751 562.9 -127.841 568.561C-122.18 474.095 -46.5834 398.498 47.8824 392.838V392.838Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M-127.82 591.324C-122.16 685.79 -46.5628 761.386 47.9029 767.047C42.2422 672.581 -33.3546 596.985 -127.82 591.324Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M70.6455 767.027C76.3062 672.561 151.902 596.965 246.368 591.304C240.708 685.77 165.111 761.366 70.6455 767.027Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M246.368 965.513C240.708 871.048 165.111 795.451 70.6455 789.791C76.3062 884.256 151.902 959.853 246.368 965.513Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M47.8824 789.791C42.2217 884.256 -33.3751 959.853 -127.841 965.513C-122.18 871.048 -46.5834 795.451 47.8824 789.791Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M-127.82 988.277C-122.16 1082.74 -46.5628 1158.34 47.9029 1164C42.2422 1069.53 -33.3546 993.938 -127.82 988.277Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M70.6455 1164C76.3062 1069.53 151.902 993.938 246.368 988.277C240.708 1082.74 165.111 1158.34 70.6455 1164Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M246.368 175.723C240.708 81.2573 165.111 5.66072 70.6455 0C76.3062 94.4657 151.902 170.062 246.368 175.723Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M47.8824 0.0200195C42.2217 94.4858 -33.3751 170.083 -127.841 175.743C-122.18 81.2775 -46.5834 5.68074 47.8824 0.0200195Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M-127.82 198.486C-122.16 292.952 -46.5628 368.549 47.9029 374.209C42.2422 279.744 -33.3546 204.147 -127.82 198.486Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M70.6455 374.209C76.3062 279.744 151.902 204.147 246.368 198.486C240.708 292.952 165.111 368.549 70.6455 374.209Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M266.844 175.723C272.504 81.2573 348.101 5.66072 442.566 0C436.906 94.4657 361.309 170.062 266.844 175.723Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M465.311 0.0200195C470.971 94.4858 546.568 170.083 641.033 175.743C635.373 81.2775 559.776 5.68074 465.311 0.0200195V0.0200195Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M641.033 198.486C635.373 292.952 559.776 368.549 465.311 374.209C470.971 279.744 546.568 204.147 641.033 198.486Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "theme-transition",
    d: "M442.547 374.209C436.886 279.744 361.29 204.147 266.824 198.486C272.485 292.952 348.081 368.549 442.547 374.209Z",
    fill: "var(--s_m_font_color)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_4507"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1728V253C1728 730.174 1341.17 1117 864 1117V1117C386.826 1117 0 730.174 0 253V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFrame);
export default __webpack_public_path__ + "static/media/Menu_Frame.84e653a2cf0bfdcf93e87a24b0cac914.svg";
export { ForwardRef as ReactComponent };